export default __webpack_public_path__ + "static/media/privatwopro.eed62fed.otf";